module.exports = ".toggleExterno {\n    margin-bottom: 22px;\n}\n\n.input-hint {\n    font-size: 12px;\n    position: absolute;\n}\n\n.input-text {\n    position: absolute;\n    font-size: 12px;\n    right: 16px;\n    top: 10px;\n}\n\n.containerText {\n    position: relative;\n}\n\n.containerSpinner {\n    position: relative;\n}\n\nspinner-component {\n    position: absolute;\n    top: -5px;\n    left: -7px;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/abastecimentos/abastecimento-bens/abastecimento-bem-form/abastecimento-bem-form.component.css
 ** module id = 419
 ** module chunks = 0
 **/